export default "__VITE_ASSET__BH0MY_IC__"